import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tous-bon-sortie-negoce',
  templateUrl: './tous-bon-sortie-negoce.component.html',
  styleUrls: ['./tous-bon-sortie-negoce.component.scss']
})
export class TousBonSortieNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
